export const LOCALSTORAGE_POSITION_KEY = "fp_pos";
export const LOCALSTORAGE_INVENTORY_KEY = "fp_inv";
export const LOCALSTORAGE_CHAPTERS_KEY = "fp_cha";
export const LOCALSTORAGE_TASK_KEY = "fp_tas";
export const LOCALSTORAGE_SOUNDSCAPE_KEY = "fp_ssc";
export const LOCALSTORAGE_FOOTSTEPS_KEY = "fp_foo";

export const START_POSITION = { lat: 52.3909043, lng: 13.7909941 };
export const START_POV = {
  heading: 279.83396999258559,
  pitch: -1.184891582816434,
};

export const MAPS_API_KEY = "AIzaSyA1VOiLnJEwz3HzcDxEExa_tCTu5KKOoqQ";

export const OBJECT_APPEAR_THRESHOLD = 10;
export const OBJECT_LOAD_THRESHOLD = 40;

export const DEFAULT_COLLECT_TEXT = "Collected";

export const HITCHHIKE_PANO = "REjdyk2fgnf3LWBQudZiGg";

export const ANIMITAS_ENDPOINT =
  process.env.NODE_ENV === "dev"
    ? "http://localhost:8787"
    : "https://animitas.finding-gustavo.quest";
